import React, { useMemo, useState } from 'react'
import clsx from 'clsx'
import { createStyles, makeStyles } from '@material-ui/core'
import { SwipeableDrawer, useMediaQuery, useTheme } from '@mui/material'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import { useFilterDrawerStyles } from '../Filters/FilterDrawer.styles'
import BraSizeGuide from './BraSizeGuide'

const useStyles = makeStyles((theme) =>
  createStyles({
    infoIcon: {
      marginLeft: theme.spacing(0.5),
      cursor: 'pointer',
      '&:hover': {
        opacity: 0.5,
      },
    },
  })
)
const drawerBleeding = 56

const BraSizeGuideDrawer = () => {
  const classes = useStyles()
  const drawerClasses = useFilterDrawerStyles()
  const theme = useTheme()

  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const handleOpen = () => {
    setIsDrawerOpen(true)
  }
  const handleClose = () => {
    setIsDrawerOpen(false)
  }
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const anchor: 'right' | 'bottom' = useMemo(() => {
    return isMobile ? 'bottom' : 'right'
  }, [isMobile])

  return (
    <>
      <InfoOutlined
        color="action"
        className={classes.infoIcon}
        onClick={handleOpen}
      />
      <SwipeableDrawer
        id="cart-menu"
        className={clsx(drawerClasses.drawer)}
        onOpen={handleOpen}
        open={isDrawerOpen}
        onClose={handleClose}
        anchor={anchor}
        swipeAreaWidth={drawerBleeding}
      >
        <BraSizeGuide />
      </SwipeableDrawer>
    </>
  )
}

export default BraSizeGuideDrawer
